import { FormProvider } from "react-hook-form";

import LoadingSpinner from "../../LoadingSpinner";

import { useApiKeyModal } from "./useApiKeyModal";

import { Stepper } from "@/components/Stepper";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { BasicTooltip } from "@/components/ui/Tooltip";

export const ApiKeyModalContent = () => {
  const {
    methods,
    open,
    activeStep,
    loading,
    cannotManageApiKeys,
    steps,
    resetDialog,
    handleNext,
    handleBack,
    handleDialogOpenChange,
  } = useApiKeyModal();

  return (
    <Dialog open={open} onOpenChange={handleDialogOpenChange}>
      <DialogTrigger asChild>
        <span>
          <BasicTooltip
            content="You don't have permission to manage API keys"
            shouldShow={cannotManageApiKeys}
          >
            <span>
              <Button
                type="button"
                onClick={resetDialog}
                disabled={loading || cannotManageApiKeys}
                size="default"
                variant="outline"
              >
                {loading ? <LoadingSpinner size={4} /> : "Generate New API Key"}
              </Button>
            </span>
          </BasicTooltip>
        </span>
      </DialogTrigger>
      <DialogContent
        className={`w-[calc(100%-2rem)] px-4 pb-4 pt-5 sm:pb-4 ${
          activeStep === 0
            ? "sm:w-[456px] sm:max-w-[456px] sm:p-6"
            : "sm:w-[700px] sm:max-w-[700px] sm:p-6"
        }`}
      >
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(() => {
              handleDialogOpenChange(false);
            })}
          >
            <Stepper
              size="dialog"
              activeStep={activeStep}
              steps={steps}
              isNextButtonLoading={activeStep === 0 && loading}
              isBackButtonVisible={activeStep !== 1}
              onNext={handleNext}
              onBack={handleBack}
              onExit={() => {
                handleDialogOpenChange(false);
              }}
            />
          </form>
        </FormProvider>
      </DialogContent>
    </Dialog>
  );
};
